import firebase from 'firebase/app'
import 'firebase/database'
import { incrementAndMaintainNumberPadding } from '@/components/Mixins/incrementAndMaintainNumberPadding'

export const handleJobMovingColumn = {
  mixins: [incrementAndMaintainNumberPadding],
  data () {
    return {
      group: this.$store.getters.group
    }
  },
  methods: {
    async handleJobMovingColumn (itemId, hasInvoice, fromList, toList, invoiceRef) {
      // onMarkAsUnSent
      if ((hasInvoice === true) && (Number(fromList) === 4) && (Number(toList) < 4)) {
        if (await this.$root.$confirm.open('Move invoiced Job?', 'This job has an invoice marked as Sent. Do you really want to move it?', { color: 'red', negative: 'No, put it back', affirmative: 'yes' })) {
          if (await this.$root.$confirm.open('Delete Invoice', 'Do you want to delete the invoice associated with this job?', { color: 'red', negative: 'No, keep it', affirmative: 'yes, delete it' })) {
            this.$store.commit('setLoading', true)
            try {
              // remove invoice activity and invoice
              var updates = {}
              updates['invoices/' + this.user.group + '/' + itemId] = null
              updates['invoices-activity/' + this.user.group + '/' + itemId] = null
              await firebase.database().ref().update(updates)
              // update the job
              const jobUpdate = {
                invoice_ref: '',
                hasInvoice: false,
                invoiced_date: ''
              }
              await firebase.database().ref(`lists/${this.user.group}/list${toList}/${itemId}/`).update(jobUpdate)
              this.$store.commit('setLoading', false)
              this.$store.dispatch('addNotification', { text: 'Invoice deleted.', type: 'error' })
            } catch (error) {
              this.$store.commit('setError', error)
              this.$store.commit('setLoading', false)
            }
          } else {
            const jobUpdate = {
              invoiced_date: ''
            }
            await firebase.database().ref(`lists/${this.user.group}/list${toList}/${itemId}/`).update(jobUpdate)
            const invoiceUpdate = {
              status: 'Unsent',
              sentTimeStamp: ''
            }
            await firebase.database().ref(`invoices/${this.user.group}/${itemId}/`).update(invoiceUpdate)
            // update the invoice actvity
            const activityMsg = {
              status: 'Marked as Unsent',
              by: this.user.email,
              created: new Date().toISOString()
            }
            // Save the activity Msg to the timeline
            await firebase.database().ref('invoices-activity/' + this.user.group + '/' + itemId).push(activityMsg)
            this.$store.dispatch('addNotification', { text: 'Invoice maked as Unsent.', type: 'primary' })
          }
        } else {
          await this.$store.dispatch('moveJob', { jobId: itemId, oldList: toList, newList: 4 })
        }
      }
      // onSaveAndMarkAsSent
      // if moved to invoiced from earlier list then set job and optionally invoice as sent
      if ((Number(fromList) < 4) && (Number(toList) === 4)) {
        try {
          // start loader
          this.$store.commit('setLoading', true)
          // update the job
          const jobUpdate = {
            invoiced_date: new Date().toISOString()
          }
          await firebase.database().ref(`lists/${this.user.group}/list${toList}/${itemId}/`).update(jobUpdate)
          // if we have an invoice then update it as paid
          if (hasInvoice) {
            // update the invoice
            const invoiceUpdate = {
              status: 'Sent',
              sentTimeStamp: new Date().toISOString()
            }
            // assign the number if not already
            // taken from this.safelyAssignInvoiceRef() in invoice.vue
            if (invoiceRef === '' && this.group.autoIncrement) {
              // assign the next number and prefix to the invoice invoice_ref
              invoiceUpdate.invoice_ref = `${this.group.autoIncrementPrefix}${this.group.nextNumber}`
              // increment the group number up one
              this.group.nextNumber = this.incrementAndMaintainNumberPadding(this.group.nextNumber)
              // save the group with the updated number
              // TODO at the moment using the json  stringify then parse ensures no undefined values are present - a bit hacky and may have overhead - investigate
              this.$store.dispatch('updateGroupSettings', JSON.parse(JSON.stringify(this.group)))
            }
            await firebase.database().ref(`invoices/${this.user.group}/${itemId}/`).update(invoiceUpdate)
            // update the invoice actvity
            const activityMsg = {
              status: 'Marked as sent',
              by: this.user.email,
              created: new Date().toISOString()
            }
            // Save the activity Msg to the timeline
            await firebase.database().ref('invoices-activity/' + this.user.group + '/' + itemId).push(activityMsg)
            // all is well so stop the loader..
            this.$store.commit('setLoading', false)
            // and dispatch the notification
            const activityText = 'Invoice marked as sent.'
            this.$store.dispatch('addNotification', { text: activityText, type: 'primary' })
          }
        } catch (error) {
          this.$store.commit('setError', error)
          this.$store.commit('setLoading', false)
        }
      }
      // onMarkAsPaid
      // if moved to paid column then set paid date and mark invoice as paid if exists
      if (Number(toList) === 5) {
        try {
          // start loader
          this.$store.commit('setLoading', true)
          // update the job
          const jobUpdate = {
            paid_date: new Date().toISOString()
          }
          await firebase.database().ref(`lists/${this.user.group}/list${toList}/${itemId}/`).update(jobUpdate)
          // if we have an invoice then update it as paid
          if (hasInvoice) {
            // update the invoice
            const invoiceUpdate = {
              status: 'Paid',
              paid_date: new Date().toISOString()
            }
            await firebase.database().ref(`invoices/${this.user.group}/${itemId}/`).update(invoiceUpdate)
            // update the invoice actvity
            const activityMsg = {
              status: 'Marked as paid',
              by: this.user.email,
              created: new Date().toISOString()
            }
            // Save the activity Msg to the timeline
            await firebase.database().ref('invoices-activity/' + this.user.group + '/' + itemId).push(activityMsg)
            // all is well so stop the loader..
            this.$store.commit('setLoading', false)
            // and dispatch the notification
            const activityText = 'Invoice marked as paid.'
            this.$store.dispatch('addNotification', { text: activityText, type: 'primary' })
          }
        } catch (error) {
          this.$store.commit('setError', error)
          this.$store.commit('setLoading', false)
        }
      }

      // if moved from paid column then clear the paid date
      if ((!hasInvoice) && (Number(fromList) === 5) && (Number(toList) < 5)) {
        try {
          this.$store.commit('setLoading', true)
          // update the job
          const jobUpdate = {
            paid_date: ''
          }
          await firebase.database().ref(`lists/${this.user.group}/list${toList}/${itemId}/`).update(jobUpdate)
        } catch (error) {
          this.$store.commit('setError', error)
          this.$store.commit('setLoading', false)
        }
      }
      // onMarkAsUnPaid
      // if there is an invoice on this job then also update the invoice if the customer chooses
      if ((hasInvoice === true) && (Number(fromList) === 5) && (Number(toList) < 5)) {
        if (await this.$root.$confirm.open('Move Paid Job?', 'This job has an invoice marked as Paid. Do you really want to move it?', { color: 'red', negative: 'No, put it back', affirmative: 'yes' })) {
          this.$store.commit('setLoading', true)
          try {
            const jobUpdate = {
              paid_date: ''
            }
            await firebase.database().ref(`lists/${this.user.group}/list${toList}/${itemId}/`).update(jobUpdate)
            const invoiceUpdate = {
              status: 'Sent',
              paid_date: ''
            }
            await firebase.database().ref(`invoices/${this.user.group}/${itemId}/`).update(invoiceUpdate)
            // update the invoice actvity
            const activityMsg = {
              status: 'Invoice marked as unpaid',
              by: this.user.email,
              created: new Date().toISOString()
            }
            // Save the activity Msg to the timeline
            await firebase.database().ref('invoices-activity/' + this.user.group + '/' + itemId).push(activityMsg)
            // all is well so stop the loader..
            this.$store.commit('setLoading', false)
            // and dispatch the notification
            const activityText = 'Invoice marked as Unpaid.'
            this.$store.dispatch('addNotification', { text: activityText, type: 'primary' })
          } catch (error) {
            this.$store.commit('setError', error)
            this.$store.commit('setLoading', false)
          }
        } else {
          await this.$store.dispatch('moveJob', { jobId: itemId, oldList: toList, newList: 5 })
        }
      }
    }
  }
}
